export const PURCHASE_ORDERS_CURRENT_PAGE_SET =
  'PURCHASE_ORDERS_CURRENT_PAGE_SET';
export const PURCHASE_ORDERS_SET = 'PURCHASE_ORDERS_SET';
export const PURCHASE_ORDERS_SHOW_MODAL_SET = 'PURCHASE_ORDERS_SHOW_MODAL_SET';



// WEBPACK FOOTER //
// ./src/components/admin/purchase-orders/store/action-types.js